import CSSPlugin from 'gsap/CSSPlugin';
import { gsap, Power4, TimelineLite }  from "gsap"; // Also works with TweenLite and TimelineLite
const myPlugins = [CSSPlugin]

const staggerProducts = function() {
	let item = document.querySelectorAll( '.product-list_item' );
	var itemDelay = .15;

	function handler( entries, observer ) {
	    var itemLoad = 0;

	    entries.forEach(entry => {
	        if ( entry.intersectionRatio > 0 ) {
	          //animate( entry.target )
	            gsap.to( entry.target, { duration: 0.5, opacity: 1, y: 0, delay: itemLoad*itemDelay, onComplete: animate( entry.target ) } )
	            itemLoad++;
	            observer.unobserve( entry.target );
	        }
	  	})
	  }

	function animate ( element ) {

	    element.classList.add( 'loaded' )

	}

	const observer = new IntersectionObserver( handler );
	for ( var i = 0; i < item.length; i++ ) {
	    observer.observe( item[i] );
	}
}

document.addEventListener('DOMContentLoaded', () => {
	if(document.querySelector('.product-list_item')){
		setTimeout(() => {
			staggerProducts()
		}, 1)

	}
})
